import type {AnimationEvent, ReactElement} from 'react';
import {useState} from 'react';
import {getAssetUrl} from '@Utils/s3.util';
import {ClickableDiv} from '@Components/clickable-div';
import {AiChatHalloweenAsset} from '@AiChat/lib/ai-chat-season-library.types';
import styles from './ai-chat-halloween-spider-web.module.scss';

export function AiChatHalloweenSpiderWeb(): ReactElement {
  const [isSpiderReeling, setIsSpiderReeling] = useState<boolean>(false);
  const [isSpiderHovered, setIsSpiderHovered] = useState<boolean>(false);

  const getHangPointStateClassName = (): string => {
    if (isSpiderReeling) {
      return styles.isReeling;
    }

    if (isSpiderHovered) {
      return styles.isSpiderHeld;
    }

    return '';
  };

  const onSpiderPointerEnter = (): void => {
    setIsSpiderHovered(true);
  };

  const onSpiderPointerLeave = (): void => {
    setIsSpiderHovered(false);
  };

  const onSpiderClick = (): void => {
    setIsSpiderReeling(true);
  };

  const onSpiderAnimationEnd = (event: AnimationEvent<HTMLDivElement>): void => {
    if (event.target !== event.currentTarget) {
      return;
    }

    setIsSpiderReeling(false);
  };

  return (
    <div className={styles.spiderWeb} aria-hidden="true">
      <img className={styles.webImage} src={getAssetUrl(AiChatHalloweenAsset.SPIDER_WEB)} alt="" />
      <div className={`${styles.hangPoint} ${getHangPointStateClassName()}`}>
        <div className={styles.thread} />
        <ClickableDiv
          className={styles.spider}
          tabIndex={-1}
          enableFocusOutline={false}
          onPointerEnter={onSpiderPointerEnter}
          onPointerLeave={onSpiderPointerLeave}
          onClick={onSpiderClick}
          onAnimationEnd={onSpiderAnimationEnd}
        >
          <img className={`${styles.spiderPart} ${styles.spiderLeftLegs}`} src={getAssetUrl(AiChatHalloweenAsset.SPIDER)} alt="" />
          <img className={`${styles.spiderPart} ${styles.spiderRightLegs}`} src={getAssetUrl(AiChatHalloweenAsset.SPIDER)} alt="" />
          <img className={`${styles.spiderPart} ${styles.spiderBody}`} src={getAssetUrl(AiChatHalloweenAsset.SPIDER)} alt="" />
        </ClickableDiv>
      </div>
    </div>
  );
}
